import React from 'react'
import { Box, Typography, Button, Card, CardContent, useTheme, useMediaQuery } from '@mui/material'
import { LoadingButton } from '../../../components/_EOS/Button/LoadingButton/LoadingButton'

interface DamageAssessmentCardProps {
  isLoading: boolean
  onMermaResponse: (isDamaged: boolean) => void
}

export const DamageAssessmentCard: React.FC<DamageAssessmentCardProps> = ({
  isLoading,
  onMermaResponse
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box mb={3}>
      <Card
        variant="outlined"
        style={{
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper
        }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary }}>
            Estado del Producto
          </Typography>
          <Typography variant="body1" gutterBottom>
            Ha indicado una cantidad a reubicar desde una posición de Venta. ¿El producto requiere ir a calidad?
          </Typography>
          <Typography variant="body2" style={{ color: theme.palette.text.secondary, marginBottom: 16 }}>
            Si requiere ir a calidad, se sugerirá mover a CALIDAD-TRANSFERENCIA.
          </Typography>
          <LoadingButton
            variant="contained"
            onClick={() => onMermaResponse(true)}
            style={{
              backgroundColor: theme.palette.warning.main,
              color: theme.palette.warning.contrastText,
              marginRight: isMobile ? 0 : theme.spacing(2),
              marginBottom: isMobile ? theme.spacing(2) : 0
            }}
            fullWidth={isMobile}
            loading={isLoading}
          >
            Sí
          </LoadingButton>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => onMermaResponse(false)}
            fullWidth={isMobile}
            disabled={isLoading}
          >
            No
          </Button>
        </CardContent>
      </Card>
    </Box>
  )
}